import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { DialogComponent } from '../dialog.component';

@Component({
  selector: 'delete-placeholder-dialog',
  templateUrl: './delete-placeholder-dialog.component.html',
  styleUrls: ['../dialog.scss']
})
export class DeletePlaceholderDialogComponent extends DialogComponent
{
  public unchangedPlaceholdersCount: number;
  public textContent: string | undefined;

  constructor(@Inject(MAT_DIALOG_DATA) protected dialogData: any)
  {
    super(dialogData);
  }
}



// WEBPACK FOOTER //
// ./src/app/dialogs/delete-placeholder-dialog/delete-placeholder-dialog.component.ts